import { post, get } from '../../../../services/request';

//-------------------TAT Data - start----------------//
// Get all TAT data
export const getAllTatData = (payload) => {
    return post(`ExamData/GetAllTATDataWithPagination`, payload);
};
//-------------------TAT Data - end----------------//